import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/styles/tokens.css'
import App from '@/App'

const container = document.getElementById('root')

if (!container) {
  throw new Error(
    'Root element #root not found. Check your index.html.'
  )
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
)
